<main
  class="dropdown-menu mb-2"
  [ngClass]="{ class: styleClass !== undefined }"
  appClickOutside
  (clickOutside)="showOptionsContainer = false"
>
  <span class="block mb-1" *ngIf="label">{{ label }}</span>
  <div class="dropdown-button" (click)="showOptionsContainer = !showOptionsContainer">
    <span>{{ selectedOption?.label }} </span>
    <i class="pi pi-chevron-down"></i>
  </div>
  <div *ngIf="showOptionsContainer" class="dropdown-options" [ngClass]="{ 'has-label': label }">
    <div *ngIf="showSearch"
      [formGroup]="filterForm"
      class="px-3 pt-1 pb-1 flex align-items-center"
      style="background-color: #f8f9fa"
    >
      <input
        type="text"
        formControlName="search"
        pInputText
        class="w-full"
        placeholder="Pretraži"
      />
      <button
        (click)="onReset()"
        class="second-btn small-btn ml-1"
        pTooltip="Obriši sve"
        tooltipPosition="top"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div *ngFor="let item of options">
      <span
        [ngClass]="{
          selected: selectedOption?.value === item[optionValue]
        }"
        class="option-label cursor-pointer"
        (click)="onSelectOption({ value: item[optionValue], label: item[optionLabel] })"
      >
        {{ item[optionLabel] }}
      </span>
    </div>
    <span *ngIf="options.length === 0" class="block m-2">Nema podataka.</span>

    <div
      *ngIf="options && options.length !== 0 && enableLoadMore"
      [class.hidden]="paginator && currentPage >= paginator?.total_pages "
      class="flex align-items-center justify-content-center mb-2"
      (click)="onLoadMore()"
    >
      <button class="second-btn small-btn">Učitaj više</button>
    </div>

    <!-- <div
      *ngIf="options.length !== 0"
      class="flex align-items-center justify-content-center mb-2"
      (click)="onLoadMore()"
    >
      <button class="second-btn small-btn">Load more</button>
    </div> -->
  </div>
</main>
